import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import { setDataAuthority } from '@/api/authority';
export default {
  name: 'Datas',
  data: function data() {
    return {
      authoritys: [],
      dataAuthorityId: [],
      needConfirm: false
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    authority: {
      default: function _default() {
        return {};
      },
      type: Array
    }
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authDataEnter();
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    self: function self() {
      var _this = this;
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return item.authorityId === _this.row.authorityId;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    selfAndChildren: function selfAndChildren() {
      var arrBox = [];
      this.getChildrenId(this.row, arrBox);
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return arrBox.indexOf(item.authorityId) > -1;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    getChildrenId: function getChildrenId(row, arrBox) {
      var _this2 = this;
      arrBox.push(row.authorityId);
      row.children && row.children.map(function (item) {
        _this2.getChildrenId(item, arrBox);
      });
    },
    // 提交
    authDataEnter: function authDataEnter() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setDataAuthority(_this3.row);
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: 'success',
                  message: "资源设置成功"
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //   平铺角色
    roundAuthority: function roundAuthority(authoritys) {
      var _this4 = this;
      authoritys && authoritys.map(function (item) {
        var obj = {};
        obj.authorityId = item.authorityId;
        obj.authorityName = item.authorityName;
        _this4.authoritys.push(obj);
        if (item.children && item.children.length) {
          _this4.roundAuthority(item.children);
        }
      });
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    }
  },
  created: function created() {
    var _this5 = this;
    this.authoritys = [];
    this.dataAuthorityId = [];
    this.roundAuthority(this.authority);
    this.row.dataAuthorityId && this.row.dataAuthorityId.map(function (item) {
      var obj = _this5.authoritys && _this5.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      }) && _this5.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      })[0];
      _this5.dataAuthorityId.push(obj);
    });
  }
};